import type { ReactNode } from 'react';

export const symbol_general_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-210q-12.75 0-21.37-8.63Q320-227.25 320-240v-540q0-24.75 17.63-42.38Q355.25-840 380-840h200q24.75 0 42.38 17.62Q640-804.75 640-780v540q0 12.75-8.62 21.37Q622.75-210 610-210H350Zm30-60h200v-510H380v510Zm-30 90h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H350q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5Zm30-90h200-200Z"
		/>
	</svg>
);
